import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Chip } from '@ibk/shared-ui';
import styles from './FilterChipGroup.module.css';
export function FilterChipGroup({ label, options, selectedIds, onChange, testIdPrefix, }) {
    const toggleOption = (id) => {
        onChange(selectedIds.includes(id) ? selectedIds.filter(selectedId => selectedId !== id) : [...selectedIds, id]);
    };
    return (_jsxs("section", { className: styles.section, "data-testid": `${testIdPrefix}-section`, children: [_jsx("h3", { className: styles.label, children: label }), _jsx("div", { className: styles.chips, children: options.map(option => (_jsx(Chip, { text: option.label, size: 'small', "data-testid": `${testIdPrefix}-${option.id}`, selected: selectedIds.includes(option.id), onClick: () => toggleOption(option.id) }, option.id))) })] }));
}
